import { titleCase } from "@/lib/format";

const MAP = {
  DRAFT: "bg-slate-100 text-slate-700 border-slate-200",
  ISSUED: "bg-blue-50 text-blue-700 border-blue-200",
  CANCELLED: "bg-slate-100 text-slate-500 border-slate-200 line-through",
  VOID: "bg-slate-100 text-slate-500 border-slate-200 line-through",
  PAID: "bg-emerald-50 text-emerald-700 border-emerald-200",
  PARTIALLY_PAID: "bg-amber-50 text-amber-700 border-amber-200",
  UNPAID: "bg-rose-50 text-rose-700 border-rose-200",
  OVERDUE: "bg-red-100 text-red-800 border-red-300",
  INTRA_STATE: "bg-blue-50 text-blue-700 border-blue-200",
  INTER_STATE: "bg-violet-50 text-violet-700 border-violet-200",
  EXPORT: "bg-teal-50 text-teal-700 border-teal-200",
};

export const StatusBadge = ({ status, label, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center rounded border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${
      MAP[status] || "bg-slate-100 text-slate-700 border-slate-200"
    }`}
  >
    {label || titleCase(status)}
  </span>
);

export default StatusBadge;
